export default "__VITE_ASSET__rv18MHTm__"